module.exports = __webpack_public_path__ + "img/emptyImg.68887ce8.jpg";